module.exports = __webpack_public_path__ + "copywriting-1.png?780367f1294169f07d9e4c46233d3b32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copywriting-1.png
// module id = 97
// module chunks = 0